import React, { useContext, useEffect } from "react";
import Spinner from 'react-bootstrap/Spinner';
/// React router dom
import {
    BrowserRouter as Router,
    Route,
    Switch
} from "react-router-dom";
/// Css
import "./index.css";
import Footer from "./layouts/Footer";
/// Layout
import Nav from "./layouts/nav";
import { ThemeContext } from "../context/ThemeContext";
import ScrollToTop from "./../ScrollToTop";

const Markup = () => {
    const { routes, menus } = useContext(ThemeContext);
    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];
    let pagePath = path.split("-").includes("page");
    let filteredRoutes = [];

    // useEffect(() => {
    //     let childMenus = []; 
    //     menus.forEach(m => {
    //         childMenus = [
    //             ...childMenus,
    //             ...m.children
    //         ]
    //     });

    //     filteredRoutes = routes.filter(r => childMenus.filter(cm => cm.url == r.url) )
    // }, [menus])


    return (
        <Router basename="/glas/">
            <div
                id={`${!pagePath ? "main-wrapper" : ""}`}
                className={`${!pagePath ? "show" : "mh100vh"}`}
            >
                {!pagePath && <Nav />}

                <div className={` ${!pagePath ? "content-body" : ""}`}>
                    <Spinner className={"spinner-none"} animation="border" />
                    <div
                        className={`${!pagePath ? "container-fluid" : ""}`}
                        style={{ minHeight: "720px", }}
                    >
                        <ScrollToTop>
                            <Switch>
                                {routes.map((data, i) => (
                                    // <PrivateRoute
                                    //   key={i}
                                    //   exact
                                    //   path={`/${data.url}`}
                                    //   component={data.component}
                                    // />
                                    <Route
                                        key={i}
                                        exact
                                        path={`/${data.url}`}
                                        //component={data.component}
                                        component={data.component}
                                        render={data.render}
                                    />
                                ))}
                            </Switch>
                        </ScrollToTop>
                    </div>
                </div>

                {!pagePath && <Footer />}
            </div>
        </Router>
    );
};

export default Markup;
